import { Service } from '@roc/feature-app-core';

const url = {
  GET_REQUEST_STATUS: '/api/v1/loan/public/getPlaidRequestStatus?url=',
  GET_LINK_TOKEN: '/api/v1/vendor/public/getPlaidLinkToken?param=',
  STORE_PLAID_ACCOUNT_INFORMATION: '/api/v1/vendor/public/storePlaidAccountInformation?params=',
  STORE_PLAID_ACH_INFORMATION: '/api/v1/vendor/public/storePlaidACHInformation',
  UPDATE_ACH_DATA: '/api/v1/vendor/public/updateACHData',
  ACH_DOCUSIGN: '/api/v1/vendor/public/achDocusign',
  ACH_LINK: '/api/v1/vendor/plaid/getACHLink',
  ACH_MANUAL_LINK: '/api/v1/vendor/plaid/getManualACHLink',
  ACH_EMAIL: '/api/v1/vendor/plaid/sendACHLink',
  GET_LOAN_ACH_SUMMARY: '/api/v1/vendor/plaid/getLoanACHSummary',
  GET_ACH_LINK_STATUS: '/api/v1/vendor/plaid/getACHLinkStatus',
  COPY_ACH_LINK: '/api/v1/vendor/plaid/copyACHLink',
  BANK_DETAILS_ACH: '/api/v1/vendor/bank-details/ACH',
};

export class PlaidService extends Service {

  getLinkToken(param) {
    return this.get(`${url.GET_LINK_TOKEN}${param}`);
  }

  getRequestStatus(id) {
    return this.get(`${url.GET_REQUEST_STATUS}${id}`);
  }

  storePlaidAccountInformation(publicToken, id) {
    return this.post(`${url.STORE_PLAID_ACCOUNT_INFORMATION}${id}`, publicToken, {
      'Content-Type': 'application/json',
    });
  }

  storePlaidACHInformation(request: any) {
    return this.post(`${url.STORE_PLAID_ACH_INFORMATION}`, request, {
      'Content-Type': 'application/json',
    });
  }

  updateACHData(request: any) {
    return this.post(`${url.UPDATE_ACH_DATA}`, request, {
      'Content-Type': 'application/json',
    });
  }

  submitDocusign(request: any) {
    return this.post(`${url.ACH_DOCUSIGN}`, request, {
      'Content-Type': 'application/json',
    });
  }

  getACHLink(loanId: any, borrowerId: any) {
    return this.get(`${url.ACH_LINK}?loanId=${loanId}&borrowerId=${borrowerId}`);
  }

  /** A link where the borrower types the bank details instead of connecting the bank (Plaid links offer no manual form). */
  getManualACHLink(loanId: any, borrowerId: any) {
    return this.get(`${url.ACH_MANUAL_LINK}?loanId=${loanId}&borrowerId=${borrowerId}`);
  }

  /** Emails a new link; MANUAL is the one where the borrower types the bank details instead of connecting the bank. */
  sendACHEmail(loanId: any, borrowerId: any, entryMode: 'PLAID' | 'MANUAL' = 'PLAID') {
    return this.get(`${url.ACH_EMAIL}?loanId=${loanId}&borrowerId=${borrowerId}&entryMode=${entryMode}`);
  }

  /** The loan's ACH account for display: bank, type, last 4 digits, saved borrower — never account numbers. */
  getLoanACHSummary(loanId: any) {
    return this.get(url.GET_LOAN_ACH_SUMMARY, { loanId });
  }

  /** The loan's newest ACH link: status and dates, never the URL (it can't be shown again, only replaced). */
  getACHLinkStatus(loanId: any) {
    return this.get(url.GET_ACH_LINK_STATUS, { loanId });
  }

  /** Puts the loan's ACH data back to before the bank account was linked (destructive). Staff roles only. */
  resetACHData(loanId: any) {
    return this.post(`${url.BANK_DETAILS_ACH}/${encodeURIComponent(loanId)}/reset`, {});
  }

  /** The open link's URL again, without replacing it. Staff only; every copy is recorded. */
  copyACHLink(loanId: any) {
    return this.post(`${url.COPY_ACH_LINK}?loanId=${encodeURIComponent(loanId)}`, {});
  }

}
